import { IPrioritable, PermanentSchedule, ScheduleItem } from '@/shared/types/settings'

export interface Service {
  key: string
  value: string
  default?: boolean
}

export enum ForwardingConditions {
  ALL = 'all',
  UNCONDITIONAL = 'unconditional',
  NO_ANSWER = 'noAnswer',
  UNREACHABLE = 'unreachable',
  BUSY = 'busy',
}

export interface Scenario {
  key: string
  value: string
}

export interface Forwarding extends IPrioritable {
  aNumber: string
  condition: ForwardingConditions
  enabled: boolean
  forwardNumber: string
  guid: string
  isDefault?: boolean
  scenario: Scenario
  schedule?: {
    permanentSchedule: PermanentSchedule,
    specialScheduleItems: ScheduleItem[]
  }
  service: Service
  timeout?: number
}
